import {
    reactive,
    watchEffect,
    computed,
    nextTick,
} from 'vue'

import {
    deepEqual,
    getType
} from '../utils/helpers'

const useASelect = (props, ctx) => {

    let store = reactive({
        state: {
            test: false,
            popupFocus: false,
            inputFocus: false,
            show: false,
            focus: false,
            filled: false,
            ...props.state
        },
        displayValue: computed(() => displayValueByType()),
        options: computed(() => buildOptions()),
        filtering: '',
        popup: {
            top: null,
            left: null,
            right: null,
            bottom: null,
            width: null,
            ['max-height']: null,
        },
        field: null,
        target: null,
        input: null,
        control: null,
    })

    watchEffect(() => {
        if (Array.isArray(props.modelValue)) {
            props.modelValue.length > 0 ? store.state.filled = true : store.state.filled = false
        } else {
            props.modelValue ? store.state.filled = true : store.state.filled = false
        }
    })

    const buildOptions = () => {
        if(!props.options) return []

        let options = Object.values(props.options)
        props.addMode ? options = addOptionValues(props.modelValue, options) : null
        props.filtering ? options = filtering(options) : null

        return options
    }

    const findValue = (val) => {
        if (getType(props.modelValue) === 'Array') {            
            for (let i = 0; i < props.modelValue.length; i++) {
                if(props.display && props.value) {
                    const type = getType(props.modelValue[i])
                    if(type === 'Object') {
                        if(val[props.value] == props.modelValue[i][props.value]) {
                            return true
                        }
                    } else {
                        if(val[props.value] == props.modelValue[i]) {
                            return true
                        }
                    }
                } else {
                    if (deepEqual(val, props.modelValue[i])) {
                        return true
                    }
                }
            }
        } else {
            if (deepEqual(val, props.modelValue)) {
                return true
            }
        }
    }

    const show = ($e) => {
        store.state.inputFocus = false
        store.state.focus = true
        store.state.show = true
        positionDetect()
        onScrollObserver(true)
    }

    const hide = () => {
        setTimeout(() => {
            onScrollObserver(false)
            store.state.show = false
        })
    }

    const toggleShow = ($e) => {
        if (store.state.focus) {
            store.state.show ? hide($e) : show($e)
        }
    }

    const onFocusin = ($e) => {
        show($e)
        if (props.filtering) {
            store.state.inputFocus = true
        }

        props.filtering && store.input.focus()
    }

    const onFocusout = ($e) => {
        store.state.focus = false
        setTimeout(() => {
            if (!store.state.popupFocus && !store.state.inputFocus) {
                hide($e)
            }
        })
    }

    const positionDetect = () => {
        nextTick(() => {
            if(!store.target || !store.field) return
            let coords = store.field.$el.getBoundingClientRect()

            store.popup.left = coords.left + 'px'
            store.popup.width = coords.width + 'px'
            
            store.popup['max-height'] = (document.documentElement.clientHeight / 2) / 100 * 90 + 'px'
            if (coords.top > document.documentElement.clientHeight / 2) {
                showTop(coords)//store.popup.top = coords.top + window.scrollY - popupRect.height + 'px'
            } else {
                showBottom(coords)
            }
            
        })
    }

    const showTop = (coords, popupRect) => {
        setTimeout(() => {
            store.popup.top = store.target ? coords.top + window.scrollY - store.target.getBoundingClientRect().height + 'px' : '0px'
        })
    }

    const showBottom = (coords) => {
        store.popup.top = coords.top + window.scrollY + coords.height + 'px'
    }

    const onScrollObserver = (check = false) => {
        if (check) {
            window.addEventListener('scroll', positionDetect)
        } else {
            window.removeEventListener('scroll', positionDetect)
        }
    }

    const popupClick = ($e) => {
        store.control.focus()
    }

    const popupFocusin = ($e) => {
        store.state.show = true
        store.state.popupFocus = true
    }

    const popupFocusout = ($e) => {
        props.filtering ? store.input.focus() : store.control.focus()
        store.state.popupFocus = false
    }

    const backspaceRemove = ($e) => {
        if ($e.code === 'Backspace' && !store.filtering && props.modelValue.length > 0 && Array.isArray(props.modelValue)) {
            props.modelValue.splice(props.modelValue.length - 1, 1)
            ctx.emit('update:modelValue', props.modelValue)
        }
    }

    const chipRemove = (i) => {
        props.modelValue.splice(i, 1)
        ctx.emit('update:modelValue', props.modelValue)
        // if ($e.code === 'Backspace' && !store.filtering && props.modelValue.length > 0 && Array.isArray(props.modelValue)) {
        //     props.modelValue.splice(props.modelValue.length - 1, 1)
        //     ctx.emit('update:modelValue', props.modelValue)
        // }
    }

    const addNewValue = ($e) => {
        if (Array.isArray(props.modelValue)) {
            if ($e.code === 'Enter' || $e.keyCode === 13) {
                ctx.emit('update:modelValue', props.modelValue.concat($e.target.value))
                resetFilter()
            }
        }
    }

    const resetFilter = () => store.filtering = ''

    const displayValueByType = () => {
        let val

        let type = getType(props.modelValue)

        if (type === 'Array') {
            if (props.modelValue.length > 0) {
                let valueType = getType(props.modelValue[0])
                if (valueType !== 'Object') {
                    val = buildArrayValue(props.modelValue)
                } else if (valueType === 'Object') {
                    val = buidArrayObjectValue(props.modelValue)
                }
            } else {
                val = []
            }
        } else if (type === 'Object') {
            val = buidObjectValue(props.modelValue)
        } else if (type !== 'Object' && type !== 'Array') {
            val = buildStringValue(props.modelValue)
        }

        return val
    }

    const buildStringValue = (model) => {
        if(!props.options) {
            return model
        }

        if(getType(props.options[0]) === 'Object') {
            const row = props.options.filter(row => {
                return row[props.value] == model
            })
            return row.length > 0 ? row[0][props.display] : ''
        } else {
            return model
        }
    }

    const buildArrayValue = (model) => model.join(props.separator)

    const buidObjectValue = (model) => model[props.display]

    const buidArrayObjectValue = (model) => model.map((item) => item[props.display]).join(props.separator)

    const addOptionValues = (model, options) => {
        if (getType(props.modelValue) !== 'Array') {
            console.error(`Model type ${getType(props.modelValue)}, must be an array`)
            return
        }
        model.forEach(item => !options.includes(item) && options.push(item))
        return options
    }

    const filtering = (options) => {
        const rows =  options.filter(v => {
            if (typeof v === 'string' || Array.isArray(v)) {
                return v.toLowerCase().indexOf(store.filtering.toLowerCase()) > -1
            } else if(typeof v === 'object') {
                return v[props.display].toLowerCase().indexOf(store.filtering.toLowerCase()) > -1
            } else {
                return v
            }
        })
        return rows
    }

    Array.prototype.indexOfObject = function (property, value) {
        for (var i = 0, len = this.length; i < len; i++) {
            if (this[i][property] === value) return i;
        }
        return -1;
    }

    const selectValue = (val) => {
        if (!props.multiple) {
            setSingleValue(val)
        } else {
            if (typeof val === 'string') {
                setArrayValue(val)
            }
            if (typeof val === 'object') {
                setObjectValue(val)
            }
            if (props.hideOnSelect) {
                hide()
            }
        }
        setTimeout(() => resetFilter())
    }

    const setSingleValue = (val) => {
        setTimeout(() => {
            store.control.blur()
            let value = val
            if(getType(props.options[0]) === 'Object') {
                value = val[props.value]
            }
            ctx.emit('update:modelValue', value)
            ctx.emit('change', value)
            store.state.show = false
            hide()
        })
    }

    const setArrayValue = (val) => {
        let values = props.modelValue
        values.includes(val) ? values.splice(values.indexOf(val), 1) : values = values.concat(val)
        ctx.emit('update:modelValue', values)
        ctx.emit('change', values)
    }

    const setObjectValue = (val) => {
        let values = props.modelValue

        if(!values) {
            values = []
        }
        if(values) {
            let idx = values.indexOfObject(props.display, val[props.display])
            idx !== -1 ? values.splice(idx, 1) : values = values.concat(val)
        }

        if(props.tags) {
            values = values.map((row) => row.hasOwnProperty(props.value) ? row[props.value] : row )
        }
        
        ctx.emit('update:modelValue', values)
        ctx.emit('change', values)
    }

    const onSearchFocus = ($e) => {
        if(store.state.show) return
        show()
        positionDetect()
        // setTimeout(() => positionDetect())
    }

    const onSearchBlur = ($e) => store.state.inputFocus = false

    const onSearchInput = ($e) => {
        store.filtering = $e.target.value
        // filtering()
        buildOptions()
        if (!store.state.show) store.state.show = true
        positionDetect()
    }

    return {
        store,
        toggleShow,
        onFocusin,
        onFocusout,
        displayValueByType,
        positionDetect,
        show,
        hide,
        backspaceRemove,
        chipRemove,
        addNewValue,
        popupClick,
        popupFocusin,
        popupFocusout,
        addOptionValues,
        filtering,
        findValue,
        selectValue,
        onSearchFocus,
        onSearchBlur,
        onSearchInput,
    }
}

export {
    useASelect
}